import { render, staticRenderFns } from "./widgDashBoard.vue?vue&type=template&id=7876f188&scoped=true&"
import script from "./widgDashBoard.vue?vue&type=script&lang=js&"
export * from "./widgDashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7876f188",
  null
  
)

export default component.exports